import { Action } from "@ngrx/store";

export const LOAD_VIBE_FILES = '[vibe-files] Load Vibe Files';
export const LOAD_VIBE_FILES_SUCCESS = '[vibe-files] Load Vibe Files Success';
export const LOAD_VIBE_FILES_FAIL = '[vibe-files] Load Vibe Files Fail';

// Action to trigger loading
export class LoadVibeFiles implements Action {
  readonly type = LOAD_VIBE_FILES;
  constructor(public payload: { domainId: number }) {} // domainId required
}

// Action dispatched when loading succeeds
export class LoadVibeFilesSuccess implements Action {
  readonly type = LOAD_VIBE_FILES_SUCCESS;
  constructor(public payload: { domainId: number; data: any }) {} // include domainId
}

// Action dispatched when loading fails
export class LoadVibeFilesFail implements Action {
  readonly type = LOAD_VIBE_FILES_FAIL;
  constructor(public payload: { domainId: number; error: any }) {} // include domainId
}

// Union type for reducer
export type VibeFilesAction =
  | LoadVibeFiles
  | LoadVibeFilesSuccess
  | LoadVibeFilesFail;
